<template>
  <v-content>
    <v-container fluid>
      <v-card class="elevation-5">
        <v-toolbar dense dark color="deep-orange" elevation="2">
          <v-toolbar-title>Empresas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="dialogNew = true">
            Agregar
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title>
          <v-btn small :loading="loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="refresh()">
            Actualizar
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="view()">
            Editar
            <v-icon right>mdi-pencil</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="view()">
            Editar
            <v-icon right>mdi-pencil</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="viewDetail()">
            Detalle
            <v-icon right>mdi-format-list-bulleted</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="viewSFTP()">
            Información para SFTP
            <v-icon right>mdi-server-security</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="dialogRemove = true">
            Eliminar
            <v-icon right>mdi-delete</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" class="mx-2" single-line hide-details maxlength="150"></v-text-field>
        </v-card-title>
        <v-data-table v-model="selected" :headers="headers" :items="items" :loading="loading" :search="search"
        :footer-props="{ 'items-per-page-text': 'Elementos por página' }" :items-per-page="5" item-key="id"
        single-select show-select class="elevation-1">
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template v-slot:footer.page-text="props">
            Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
          <template v-slot:no-data>
            No hay información disponible
          </template>
          <template v-slot:no-results>
            No se obtuvieron resultados
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialogNew" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Nuevo registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="save()">
              Guardar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formNew" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.idexterno" label="Idexterno" :rules="formRules.idexterno" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.nombre" label="Nombre" :rules="formRules.nombre" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.razon_social" label="Razón social" :rules="formRules.razon_social" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.direccion_fiscal" label="Dirección fiscal" :rules="formRules.direccion_fiscal" :counter="250" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="formNew.pagina_web" label="Página web" :rules="formRules.pagina_web" :counter="100" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="formNew.nombre_contacto" label="Nombre de contacto" :rules="formRules.nombre_contacto" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="formNew.telefono_contacto" label="Teléfono de contacto" :rules="formRules.telefono_contacto" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="formNew.email_contacto" label="Email de contacto" :rules="formRules.email_contacto" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogUpdate" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Actualizar registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="update()">
              Actualizar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formUpdate" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.idexterno" label="Idexterno" :rules="formRules.idexterno" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.nombre" label="Nombre" :rules="formRules.nombre" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.razon_social" label="Razón social" :rules="formRules.razon_social" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.direccion_fiscal" label="Dirección fiscal" :rules="formRules.direccion_fiscal" :counter="250" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="formUpdate.pagina_web" label="Página web" :rules="formRules.pagina_web" :counter="100" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="formUpdate.nombre_contacto" label="Nombre de contacto" :rules="formRules.nombre_contacto" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="formUpdate.telefono_contacto" label="Teléfono de contacto" :rules="formRules.telefono_contacto" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="formUpdate.email_contacto" label="Email de contacto" :rules="formRules.email_contacto" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDetail" persistent max-width="1500px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Detalle de registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="updateDetail()">
              Actualizar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formUpdate" lazy-validation>
                <v-row>
                  <v-col cols="12" lg="4">
                    <v-row>
                      <v-col cols="12">
                        <v-file-input v-model="formDetail.file" chips small-chips show-size  label="Seleccionar imagen..." accept="image/png" :disabled="loading" required @change="getImage()" dense outlined></v-file-input>
                      </v-col>
                      <v-col v-if=" formDetail.logo" cols="12">
                        <v-card>
                        <v-card-text>
                          <v-img :src="formDetail.logo" max-height="500" contain/>
                        </v-card-text>
                      </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" lg="2">
                    <v-row>
                      <v-col cols="12">
                        <v-autocomplete v-model="formDetail.color_primario" :items="catalogues.colores" label="Color primario" :disabled="loading" dense outlined></v-autocomplete>
                      </v-col>
                      <v-col cols="12">
                        <v-autocomplete v-model="formDetail.color_secundario" :items="catalogues.colores" label="Color secundario" :disabled="loading" dense outlined></v-autocomplete>
                      </v-col>
                      <v-col cols="12">
                        <v-autocomplete v-model="formDetail.color_terciario" :items="catalogues.colores" label="Color terciario" :disabled="loading" dense outlined></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-row>
                      <v-col cols="12">
                        <v-textarea v-model="formDetail.texto_personalizado_1" label="Texto personalizado 1" :disabled="loading" dense outlined></v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea v-model="formDetail.texto_personalizado_2" label="Texto personalizado 2" :disabled="loading" dense outlined></v-textarea>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogSFTP" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Detalle de registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="updateSFTP()">
              Actualizar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formUpdateSFTP" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="formSFTP.nombre_de_carpeta" label="Nombre de la carpeta" :rules="formRules.nombre_de_carpeta" :counter="250" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formSFTP.usuario_sftp" label="Ususario sftp" :rules="formRules.usuario_sftp" :counter="250" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formSFTP.pass_sftp" label="Contraseña sftp" :rules="formRules.pass_sftp" :counter="250" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formSFTP.puerto" label="Puerto" :rules="formRules.puerto" :counter="250" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formSFTP.host" label="Host" :rules="formRules.host" :counter="250" :disabled="loading" required></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogRemove" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Aviso</v-card-title>
          <v-card-text>¿Realmente desea eliminar el registro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" color="primary" @click="cancel()">
              Cancelar
            </v-btn>
            <v-btn text small :loading="loading" color="error" @click="remove()">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
        {{ msgError }}
      </v-snackbar>
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
    </v-container>
  </v-content>
</template>

<script>
import services from '@/utils/services'
import Vue from 'vue'

export default {
  name: 'empresas',
  data: () => ({
    loading: false,
    error: false,
    msgError: '',
    success: false,
    msgSuccess: '',
    catalogues: {
      colores: [
        'rojo oscuro',
        'rojo claro',
        'azul oscuro',
        'azul claro',
        'verde oscuro',
        'verde claro',
        'negro',
        'gris'
      ]
    },
    search: '',
    headers: [
      { text: 'Idexterno', align: 'center', sortable: false, value: 'idexterno' },
      { text: 'Nombre', align: 'center', sortable: false, value: 'nombre' },
      { text: 'Razón social', align: 'center', sortable: false, value: 'razon_social' },
      { text: 'Dirección fiscal', align: 'center', sortable: false, value: 'direccion_fiscal' },
      { text: 'Página web', align: 'center', sortable: false, value: 'pagina_web' },
      { text: 'Nombre contacto', align: 'center', sortable: false, value: 'nombre_contacto' },
      { text: 'Email contacto', align: 'center', sortable: false, value: 'email_contacto' },
      { text: 'Fecha actualización', align: 'center', sortable: false, value: 'fecha_cambio' }
    ],
    items: [],
    selected: [],
    dialogNew: false,
    dialogUpdate: false,
    dialogDetail: false,
    dialogSFTP: false,
    dialogRemove: false,
    formNew: {
      idexterno: '',
      nombre: '',
      razon_social: '',
      direccion_fiscal: '',
      pagina_web: '',
      nombre_contacto: '',
      telefono_contacto: '',
      email_contacto: ''
    },
    formUpdate: {
      id: '',
      idexterno: '',
      nombre: '',
      razon_social: '',
      direccion_fiscal: '',
      pagina_web: '',
      nombre_contacto: '',
      telefono_contacto: '',
      email_contacto: ''
    },
    formDetail: {
      file: null,
      logo: null,
      color_primario: null,
      color_secundario: null,
      color_terciario: null,
      texto_personalizado_1: null,
      texto_personalizado_2: null
    },
    formSFTP: {
      nombre_de_carpeta: null,
      usuario_sftp: null,
      pass_sftp: null,
      puerto: null,
      host: null,
    },
    formRules: {
      idexterno: [
        v => !!v || 'El idexterno es obligatorio',
        v => (v && v.length <= 50) || 'El idexterno excede la longitud máxima'
      ],
      nombre: [
        v => !!v || 'El nombre es obligatorio',
        v => (v && v.length <= 150) || 'El nombre excede la longitud máxima'
      ],
      razon_social: [
        v => !!v || 'La razón social es obligatoria',
        v => (v && v.length <= 150) || 'El nombre excede la longitud máxima'
      ],
      direccion_fiscal: [
        v => !!v || 'La dirección fiscal es obligatoria',
        v => (v && v.length <= 250) || 'La dirección fiscal excede la longitud máxima'
      ],
      nombre_de_carpeta: [
        v => !!v || 'Es obligatorio',
        v => (v && v.length <= 250) || 'La dirección fiscal excede la longitud máxima'
      ],
      usuario_sftp: [
        v => !!v || 'Es obligatorio',
        v => (v && v.length <= 250) || 'La dirección fiscal excede la longitud máxima'
      ],
      pass_sftp: [
        v => !!v || 'Es obligatorio',
        v => (v && v.length <= 250) || 'La dirección fiscal excede la longitud máxima'
      ],
      puerto: [
        v => !!v || 'Es obligatorio',
        v => (v && v.length <= 250) || 'La dirección fiscal excede la longitud máxima'
      ],
      host: [
        v => !!v || 'Es obligatorio',
        v => (v && v.length <= 250) || 'La dirección fiscal excede la longitud máxima'
      ],
      pagina_web: [
        v => !!v || 'La página web es obligatoria',
        v => (v && v.length <= 100) || 'La página web excede la longitud máxima'
      ],
      nombre_contacto: [
        v => !!v || 'El nombre de contacto es obligatorio',
        v => (v && v.length <= 150) || 'El nombre de contacto excede la longitud máxima'
      ],
      telefono_contacto: [
        v => !!v || 'El teléfono es obligatorio',
        v => (v && v.length <= 50) || 'El teléfono de contacto excede la longitud máxima'
      ],
      email_contacto: [
        v => !!v || 'El email de contacto es obligatorio',
        v => (v && v.length <= 50) || 'El email de contacto excede la longitud máxima',
        v => /.+@.+\..+/.test(v) || 'El email de contacto es inválido'
      ]
    }
  }),
  mounted() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      services.ws('get', 'empresas')
        .then(res => {
          if (res.ok) {
            this.items = res.data.empresas
            this.selected = []
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    clear() {
      if (this.$refs.formNew) {
        this.$refs.formNew.reset()
      }
      else if (this.$refs.formUpdate) {
        this.$refs.formUpdate.reset()
      }
      else if (this.$refs.formDetail) {
        this.formDetail = {
          file: null,
          logo: null,
          color_primario: null,
          color_secundario: null,
          color_terciario: null,
          texto_personalizado_1: null,
          texto_personalizado_2: null
        }
      }
      else if(this.$refs.formUpdateSFTP) {
        this.$refs.formUpdateSFTP.reset();
      }
      for (let key in this.formNew) {
        this.formNew[key] = ''
      }
      for (let key in this.formUpdate) {
        this.formUpdate[key] = ''
      }
    },
    cancel() {
      this.clear()
      this.selected = []
      this.dialogNew = false
      this.dialogUpdate = false
      this.dialogDetail = false
      this.dialogRemove = false
      this.dialogSFTP = false;
    },
    save() {
      if (this.$refs.formNew.validate()) {
        this.loading = true
        setTimeout(() => {
          services.ws('post', 'nuevaEmpresa', this.formNew)
            .then(res => {
              if (res.ok) {
                this.cancel()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }, 800)
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos son inválidos'
      }
    },
    view() {
      this.formUpdate = JSON.parse(JSON.stringify(this.selected[0]))
      this.dialogUpdate = true
    },
    update() {
      if (this.$refs.formUpdate.validate()) {
        this.loading = true
        setTimeout(() => {
          services.ws('post', 'actualizarEmpresa', this.formUpdate)
            .then(res => {
              if (res.ok) {
                this.cancel()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }, 800)
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos son inválidos'
      }
    },
    remove() {
      this.loading = true
      setTimeout(() => {
        let id = this.selected[0].id
        services.ws('post', 'eliminarEmpresa', { id })
          .then(res => {
            if (res.ok) {
              this.cancel()
              this.refresh()
              this.success = true
              this.msgSuccess = res.message
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }, 800)
    },
    viewDetail() {
      this.loading = true
      let jwt = Vue.prototype.$session.get('jwt')
      let headers = {
        'Authorization': 'Bearer ' + jwt
      }
      this.axios({
        url: services.routes.detalleEmpresa + '?id=' + this.selected[0].id,
        method: 'GET',
        headers: headers
      })
      .then((response) => {
        this.formDetail.logo = (response.data.logo) ? 'data:image/png;base64,' + response.data.logo : null,
        this.formDetail.color_primario = response.data.color_primario,
        this.formDetail.color_secundario = response.data.color_secundario,
        this.formDetail.color_terciario = response.data.color_terciario,
        this.formDetail.texto_personalizado_1 = response.data.texto_personalizado_1,
        this.formDetail.texto_personalizado_2 = response.data.texto_personalizado_2,
        this.dialogDetail = true
      })
      .catch(() => {
        this.error = true
        this.msgError = 'El detalle de la empresa no fue obtenido'
      })
      .finally(() => {
        this.loading = false
      })
    },
    viewSFTP() {  
      this.loading = true
      let jwt = Vue.prototype.$session.get('jwt')
      let headers = {
        'Authorization': 'Bearer ' + jwt
      }
      /*actualizarEmpresaSFTP
        consultaEmpresaSFTP*/
      this.axios({
        url: services.routes.consultaEmpresaSFTP + '?id=' + this.selected[0].id,
        method: 'GET',
        headers: headers
      })
      .then((response) => {
        console.log(response.data);
        this.formSFTP.nombre_de_carpeta = response.data.nombre_de_carpeta;
        this.formSFTP.usuario_sftp = response.data.usuario_sftp;
        this.formSFTP.pass_sftp = response.data.pass_sftp;
        this.formSFTP.puerto = response.data.puerto;
        this.formSFTP.host = response.data.host;
        
        this.dialogSFTP = true;
      })
      .catch((error) => {
        console.log(error)
        this.error = true
        this.msgError = 'El detalle de la empresa no fue obtenido'
      })
      .finally(() => {
        this.loading = false
      })
    },
    updateSFTP() {
      this.loading = true
      let jwt = Vue.prototype.$session.get('jwt')
      let headers = {
        'Authorization': 'Bearer ' + jwt
      }
      let data = {
        id: this.selected[0].id,
        nombre_de_carpeta: this.formSFTP.nombre_de_carpeta,
        usuario_sftp: this.formSFTP.usuario_sftp,
        pass_sftp: this.formSFTP.pass_sftp,
        puerto: this.formSFTP.puerto,
        host: this.formSFTP.host,
      }
      this.axios({
        url: services.routes.actualizarEmpresaSFTP,
        method: 'POST',
        headers: headers,
        data: data
      })
      .then(() => {
        this.cancel()
        this.success = true
        this.msgSuccess = 'La información sftp de la empresa fue actualizado'
      })
      .catch(() => {
        this.error = true
        this.msgError = 'La información sftp de la empresa no fue actualizado'
      })
      .finally(() => {
        this.loading = false
      })
    },
    getImage() {
      if (this.formDetail.file) {
        let fr = new FileReader();
        let file = this.formDetail.file
        let size = file.size
        if (size <= 1000000) {
          fr.onload = () => {
            this.formDetail.logo = fr.result
          }
          fr.onerror = () => {
            this.loading = false
            this.formDetail.file = null
            this.error = true
            this.msgError = 'El archivo no fue leído correctamente'
          }
          fr.readAsDataURL(file);
        }
        else {
          this.error = true
          this.msgError = 'El archivo ha excedido el límite permitido (1 MB)'
        }
      }
    },
    updateDetail() {
      this.loading = true
      let jwt = Vue.prototype.$session.get('jwt')
      let headers = {
        'Authorization': 'Bearer ' + jwt
      }
      let data = {
        id: this.selected[0].id,
        detalle: {
          logo: (this.formDetail.logo) ? this.formDetail.logo.split(',')[1] : null,
          color_primario: this.formDetail.color_primario,
          color_secundario: this.formDetail.color_secundario,
          color_terciario: this.formDetail.color_terciario,
          texto_personalizado_1: this.formDetail.texto_personalizado_1,
          texto_personalizado_2: this.formDetail.texto_personalizado_2
        }
      }
      this.axios({
        url: services.routes.actualizarDetalleEmpresa,
        method: 'POST',
        headers: headers,
        data: data
      })
      .then(() => {
        this.cancel()
        this.success = true
        this.msgSuccess = 'El detalle de la empresa fue actualizado'
      })
      .catch(() => {
        this.error = true
        this.msgError = 'El detalle de la empresa no fue actualizado'
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
